var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("OptionsUI", {
    ref: "UI",
    attrs: {
      skin: _vm.skin,
      dataModel: _vm.dataModel,
      showLoading: _vm.showLoading,
      errorCode: _vm.error.code,
      settings: _vm.settings,
      labels: _vm.initedLabels,
      formatter: _vm.formatter
    },
    on: {
      track: _vm.trackEvent,
      "expiration-date-changed": _vm.changeExpiration,
      "settings-changed": _vm.changeSettings,
      "settings-popover-hide": _vm.hideSettingsPopover,
      "visible-rows-update": _vm.visibleRowsUpdate,
      "greeks-view-changed": _vm.changeGreeksView
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }